
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexpTGrbthPQINc0PqbA1Zl7qN3X2wNKUSV4eQ6UpPbi40Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/index.vue?macro=true";
import { default as loginog2sPHO_hG61Uzegq_45LbnDPuihr5xgG1IMjpaEar_gwMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/login.vue?macro=true";
import { default as verifyew3oQMFfwgDTsYxHMJcTqhoTMZsJn2HJKzdD5EoawsQMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/verify.vue?macro=true";
import { default as sitemapaKB39UlrL03mhRJMeeBo0WcDfizkn8P20nifosqa4CQMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/sitemap.vue?macro=true";
import { default as about_45uskfUfDLe6r_45ZwCWdXhvV6c0N_45RurRrozW0ySGelV0MgkMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/about-us.vue?macro=true";
import { default as registerG7sciBTzkby359gllzx810eBEaYf8tmM4QPw_mPGle0Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/register.vue?macro=true";
import { default as complaintssyWNIafOo1he_45BUh4EMdFhiJOwefhP_45lb_BlfELAwbkMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/complaints.vue?macro=true";
import { default as contact_45usCbXo_45QvGbdoXaQQ8Uo7vaPvP7ASrHAnN2mG4TDtFi4AMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/contact-us.vue?macro=true";
import { default as indexCsonVej8NfCnwPh6e_lqknAAkeY_45wW0E4ANROEY3_45AAMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/media/index.vue?macro=true";
import { default as indexWUZ7uzN70JqR37sikpuasy0b_45Zm9TiWI1aFMLUe2TUoMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/index.vue?macro=true";
import { default as _91slug_93nOmBuu9MNMYhEr_45_DRZ_6rwNxYsRILoJGGU_AkbpCVkMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/media/[slug].vue?macro=true";
import { default as partnershipsBmVzlkjAt9dKOBG1rfDF74xdr2ZuYvg2NSfuDCkPAQsMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/partnerships.vue?macro=true";
import { default as terms_45of_45useH1AnyABe4_45jxTLYb9ws_m2RtzBMw0LfT_45wL_962AueAMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/terms-of-use.vue?macro=true";
import { default as indexIi0gI8u0avamxbRfz7yy7QZChmdDUCJ9WOjHLDVYy2IMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/careers/index.vue?macro=true";
import { default as privacy_45policyzqa1G4fCIMTRghD2MRL7OdtTNPVk4VG3bn3VK_45ycFIEMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/privacy-policy.vue?macro=true";
import { default as reset_45passwordf0eIsG3IKPudThiZJgHNcK3ewcG4hurjdU_45PT_2j7egMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/reset-password.vue?macro=true";
import { default as indexWUvtJmIG8D23bA3rAUgwtmll0tTtd4iUZ__xWIYMPdkMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/car-loans/index.vue?macro=true";
import { default as indexaHrh0MOiNfMNZ6r_45uN3KHGFxJSCzEAtCqQswibhBSNkMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/index.vue?macro=true";
import { default as forgot_45passwordatDE7ddcTDvbx2edQwBjH5Sjpv37evz7R_nmOtv91TsMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/forgot-password.vue?macro=true";
import { default as index_45xAY1XrAnMLB6DR0JRvFVgnV8bj18N_45Yq7HtwfOqnY4Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/index.vue?macro=true";
import { default as _91slug_93KbeylcyifOcgF_45AwkT9WZJh4v4djt8YTmRRKgLsvyWEMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/[slug].vue?macro=true";
import { default as guidesODu5IJQFSVJsoq08LZF9PZkJ83XvGC2HPcXwvtIJ3KsMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/guides.vue?macro=true";
import { default as collection_45noticeBIsW_Ec83OSJwxzZo68z9Zllsct4fVmhHDBPa8Nn_EYMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/collection-notice.vue?macro=true";
import { default as indexevyfkCciHSJFPbprWXebn8us0OIK_d8_9cDmiWeQIHgMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/credit-cards/index.vue?macro=true";
import { default as set_45passwordg1ZyyzuvkFp2TSQo3vTZ_45q8m_uqqj2X7aanbm_45fUTKkMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/guest/set-password.vue?macro=true";
import { default as welcome_45backIYBtBjrHLiWWhEOSClyD3b9yTe5F054izLU05S5CWVEMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/guest/welcome-back.vue?macro=true";
import { default as mergeQrvaRzYfIaR5RTYcYhqELVEMvv8iberhaEeLtdHiIbEMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/authorization/merge.vue?macro=true";
import { default as index1NoGPL4si7jhPuVU6a75jrwLUPAM15psGjKzChSVnyAMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/car-insurance/index.vue?macro=true";
import { default as _91slug_93c_45UlylyxjnA4Pt0zZoFPge1iUazWLZylKk90e1l1H0IMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/credit-cards/[slug].vue?macro=true";
import { default as post_45sale_45thank_45you7jTTc_45GlRgjMhB_Z1XKzKKT6M_45CT86nr6up6R06sVrUMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/post-sale-thank-you.vue?macro=true";
import { default as indexSxp3rP3MrarJ5LopkhAOV9VjcxYkVwIqLpKZJhhRaeQMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/index.vue?macro=true";
import { default as indexE2_45l35noMLbVwJiM3Zc7Xm6q8EpyeMAlashpPhwzFzkMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/personal-loans/index.vue?macro=true";
import { default as _91slug_93vdhYiPBbbrQw6zpzsqCHHnKI9jZhIHmFrLS5hXNTWSkMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/preview/media/[slug].vue?macro=true";
import { default as indexURf63AA1_c0QOFCUdIdIbQy2fEg5bck9D9k0Iw_45Rw3IMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/perks/index.vue?macro=true";
import { default as indexRSxncZ0dfpu817J2q0ZDKCYejnRIgt7109bCdR5VhgEMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/expert-analysis/index.vue?macro=true";
import { default as _91author_931UtayvRMsaJXcgxtm74hh3wwJF_45TqgUr4DASakqV938Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/media/author/[author].vue?macro=true";
import { default as callbackMbtzJxwf4mgv_M_faZmbeB6LZA13RHM34ZZyUTl6DHMMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/authorization/callback.vue?macro=true";
import { default as buyer_45protection_45claimE1KlhL9BjAa16cu00ss3qnMDKzXFJjG_OXu8_gyt_vcMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/buyer-protection-claim.vue?macro=true";
import { default as index2vfFVvzJ3c5nh6Ip7PlQMFZbOgm_45BKl4vvwHoUfWAzwMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/quotes/index.vue?macro=true";
import { default as thank_45you_45vqZAg_78GKjyiyzhNsM0Hhx7cFXfHgI_meJRbJiecQMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/quote/thank-you.vue?macro=true";
import { default as errorJXk28tnmaNLDhyHb62UmW4ndajr0LDTU13_45goDovsegMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/error.vue?macro=true";
import { default as indexfH8oURJk2kEkcccQumhkbEdAiwfBP5JOA7DDc_tOUFsMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/index.vue?macro=true";
import { default as index5J1kQPhqqcS_nvX1OkG_sPqSH7VrNYSYV_ylgHAWJiwMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/rewards/index.vue?macro=true";
import { default as erroraxZbOxosgkNRPj235zqmM5yR9IcUANhVG1XazUDV7jsMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/application/error.vue?macro=true";
import { default as _91step_93wcDmKnwPhFNEyS3O_45La9CZRsuQqW6tmRdkofY48u_45_45IMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/quote/form/[step].vue?macro=true";
import { default as detailsRarTW5UbpPUbFPei4AviZ48KQx_ftU5RR_45o_1UJ9eL0Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/quote/form/details.vue?macro=true";
import { default as interest_45ratesEIkBZpf1rqTYxgPPIAj_45K3f6G3TWacS7RhBfLb135owMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/interest-rates.vue?macro=true";
import { default as _91slug_935RDGV0Wj00mTq0XyzYM11kTcLgFF_kxkmjss2D4bIgAMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/preview/[vertical]/[slug].vue?macro=true";
import { default as indexswj28rc2Ru58PKKa1EVckTwQQ_45FcLymxEAWLJT0YHY8Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/companies/index.vue?macro=true";
import { default as account_45settingsE4wubMrkqeWsUVkmBhN_45bKA8LEjLNwDgb2FeUmCDw_gMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/account-settings.vue?macro=true";
import { default as index55q5hRmdg8akjtfbr_45Z0EakWMwgXEndeesM074ed26gMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/onboarding/index.vue?macro=true";
import { default as live_45chat_45S20czdaObDEEPwSZpf920YG1uwpdaMoxIag_CWqqH4Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/live-chat.vue?macro=true";
import { default as post_45saleu5g6M8IXc7vCQ4YVPkOvkWR7NYtmkvwfb7M_S1XP11sMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/post-sale.vue?macro=true";
import { default as thank_45yousNVoUNEmEu77vpHoKfPjYd3y_45wIVVW2_j5iqAT3s2WYMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/quote/thank-you.vue?macro=true";
import { default as comprehensivedGrXC9JE83s4JB6DIZzNW3vgrFXuXmT_45CJN23Sd9CqIMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/car-insurance/comprehensive.vue?macro=true";
import { default as _91slug_93zDeUS9pyXbYMEpGFjpKW12D_45zhd6tuzPebhVLouBc8AMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/credit-cards/preview/[slug].vue?macro=true";
import { default as addO0Y3FoqtsMWHZpMp_45uxZspuSNJKt1ErL1hb0N_JNMGUMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/partners/add.vue?macro=true";
import { default as index_D5FYITD4BljUk2vOV5GhaaxPiuz5yJitfn_OVivqQIMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/schedule-callback/index.vue?macro=true";
import { default as _91response_93xX3tfa7WPhcXtcfvUvcZo_ds8WoQQG93yXk5d1fheYcMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/schedule-callback/[response].vue?macro=true";
import { default as schedule_45callbackC2A1Yh94GmZeqKIvMlCSl7s57ytHudcLrHzHFwz0G08Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/schedule-callback.vue?macro=true";
import { default as _91slug_93cxgi8KGWLy2LbxQck1LF1mMoxTHnWzWUHRsTa2QDHVAMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/credit-cards/redirect/[slug].vue?macro=true";
import { default as thank_45youJBE_Fh7h8mrTcNTowKuJ7QGObaV2xZE3dVhGCpfdG2IMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/application/thank-you.vue?macro=true";
import { default as live_45chat_45blNWBlm0Yoirfe1IMROQdy_yLdsqTGR2nj2rnAQ0w3hgMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/live-chat-b.vue?macro=true";
import { default as indexg7OsHUmbw84_45zlITFBAcqGkmJR_zAI4F5piJYrrIa6IMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/calculators/index.vue?macro=true";
import { default as _91step_93afaCZFDbT8qzDRLHcm0KVF50JrxgwT083nyS4IrSUt4Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/quote/form/[step].vue?macro=true";
import { default as _91slug_93T33EtDrB_sQorYCmxlpoFOy6dsQb_45e4f_TqXNxrA40YMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/car-insurance/redirect/[slug].vue?macro=true";
import { default as indexuUJY8kusQNBskqrvtidrjFftsuhluVAP8qSDmzd13xUMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/offers/index.vue?macro=true";
import { default as addDp3V4MmgKX230r9OyFI1kEiz0i1ziTCqRCtd20mGJK0Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/partners/add.vue?macro=true";
import { default as _91type_936YaT6cRG48NC5pxXabFLcQ_4xErzGWf3lKVkGv44GXIMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/calculators/[type].vue?macro=true";
import { default as details5AhgB3oAz82v957mHhrVSxPhO7uKOQURvsmv6v1Q4DAMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/quote/form/details.vue?macro=true";
import { default as callback9scwntgXmhJyI9c6yYzq57lLYO57YRTx_MWV7gvGvvIMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/quote/callback.vue?macro=true";
import { default as digital_45eico5wKe9ZvYXLweecVHPL5yu2_45mOaS_CGx8kJW3Di53ZUMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/application/digital-eic.vue?macro=true";
import { default as thank_45you38g_45XT_45fIJuPXloc25_45_MJOzQ7PPhCx77ykUjobmz0gMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/personal-loans/quote/thank-you.vue?macro=true";
import { default as _91step_938VvCprViW81VEHL2kAKoP44k_rImNrlOVWKJvcudb7cMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/car-insurance/quote/form/[step].vue?macro=true";
import { default as _91author_93r7OdFpxwSj0JEB5s5h4OtdpuJ4jOmQIQUGHkWudaFIcMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/expert-analysis/author/[author].vue?macro=true";
import { default as comparisonv5upizX9f_45NBP2rjHRO5XIyuYXwWQteiue02c4luD74Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/quote/comparison.vue?macro=true";
import { default as step1NnT79_45rbR8psVR2wkZqrU7YMRymo5oB4QAYdc2MKOM8Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/quote/form/step1.vue?macro=true";
import { default as details9c6CpqdCTxdbwQegtUz2XuxUixkTMsc1sam5PKNJLHIMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/car-insurance/quote/form/details.vue?macro=true";
import { default as resultsLs3oRdoX6LeJOSWzjrSFuHuvW8gxX96yhKNKjyw5a_AMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/car-insurance/quote/form/results.vue?macro=true";
import { default as index59v5wcjs4qsBl4hUPIvbSaVnYEz2dM_yhyrjB3spLNEMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/expert-analysis/[category]/index.vue?macro=true";
import { default as signup171hZmgHFVZja7G47pXbJo80OP_45zPEj_45s_45eY1Q9YRNwMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/partners/signup.vue?macro=true";
import { default as thank_45youTIZYaxbzbGZhwY1fxKQswEMHFj1E6fy4MrUwMTLrAC8Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/thank-you.vue?macro=true";
import { default as _91step_93V8WH5MdfbbcgjY_45X_45OblyMcgtPu66pIcwIKQN6sQY4wMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/personal-loans/quote/form/[step].vue?macro=true";
import { default as _91slug_93MJ9OXrG6vyAt4qmqhWTelGrIiT5zBx42N_WckLexBaUMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/expert-analysis/[category]/[slug].vue?macro=true";
import { default as step0cl_45UhIeBKmJiCgh1HE9QiyDWcrNW8LH3SIAp0b1nYzgMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/form/step0.vue?macro=true";
import { default as existing_45customersc3Nz2bpVUxxK_45_45Bs_45PqV30__S1GDSYucnGHnO6Kj8K8Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/existing-customers.vue?macro=true";
import { default as thank_45youOKSjgl2O0l9SP6DcqgToxLgbkV5RG2jtjxGlUTHtEKsMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/partners/thank-you.vue?macro=true";
import { default as details21DJy1u8jX7l5cdowFTXuJ5vaM1FVUOyvUjfWSTZKJIMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/quote/form/details.vue?macro=true";
import { default as detailsHUJsNWzHcWsWWi2hTeivTE_HldKoozmbUMcmDQpnFS0Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/personal-loans/quote/form/details.vue?macro=true";
import { default as _91step_93yWU6XfeYEZGi0kWXNRQ5138uEGZNzW1TnZ_455INaDB70Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/form/[step].vue?macro=true";
import { default as rebateHCRYRh3_45035anWCc1xo_45AyZ1DgUP_45OB3WxfiGDPT1qUMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/rebate.vue?macro=true";
import { default as _91step_930ImC38tYXeev9t1_7rl_45xZTbkmqd7E0HiJZMfegbjVoMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/application/[step].vue?macro=true";
import { default as detailsEr3_45OPMFtfDANpDWHhELz5pSOrDLRdoMlJHGqCTGJk8Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/form/details.vue?macro=true";
import { default as step0OUszj0Bm8UAHsB2F6JB7Ky9q9xlhtGmJtZtIXB49eF4Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/policy/step0.vue?macro=true";
import { default as indexnApyeHyUGmKYhokpwDBC9SYvf1HdtCKSnXR0nH2rHjcMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/resume/index.vue?macro=true";
import { default as index4A_45OpBalOD_v8YMPaCVhphx2IdRYl4TwV6IW2r8bDrQMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/quote/customer/index.vue?macro=true";
import { default as detailsZWp4EL_0mmsBdDe1llfc_YOKYSvMcI_3ClH5QD0ZGG4Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/details.vue?macro=true";
import { default as terms_45and_45conditionsUBPyH5VxW6_u5r54rC6EDdz_45EjwzGSDMzBOng5G5jZAMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/buyer-protection/terms-and-conditions.vue?macro=true";
import { default as _91location_93ZEIgNGvzZQlwjZa_sSdgVCOPwddIBbS8gzkR0rLZwyEMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/compare-by-location/[location].vue?macro=true";
import { default as indexyt0snZyU0_SIOii0MZOBPSnWWA6fH_45YHxzJWwmi08MAMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/customer/index.vue?macro=true";
import { default as details0wpjlFoMKlixv1grtQ_sbQHix8VYXWSxD_iRo2dg6y8Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/policy/details.vue?macro=true";
import { default as indexpIe2H5c2cY0kE3_45Iy7skuBGA5lFDDaZCYrfIZCNPZTMMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quotes-results/index.vue?macro=true";
import { default as successR3lihFY5Q2izyBZlPO_31Ibh_45uNtadItZFd302Z6tL0Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/quote/customer/success.vue?macro=true";
import { default as claim_45offercrYMue8gQwzisfW4r_45LEnQ9lhhgE_45srW8iwc3CoH_5AMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/offers/[vertical]/claim-offer.vue?macro=true";
import { default as lic_45detailsLQm1zSH1ZlZua_B3OKpDwHFDJThZ_1Pco0fNccqyNP0Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/lic-details.vue?macro=true";
import { default as _91step_93h3bdpxOh_45VJLe6CWJqz2dl2aQ6Bjjmxk9QA_VLpeUrMMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/policy/step/[step].vue?macro=true";
import { default as indexNnrPna24vfj0ZtnxhYTo6U_45PFUrXfjbt_NJTO3JGFsgMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/index.vue?macro=true";
import { default as _91slug_93yr_LZCLwgfClPQe8Hpgcb9FHQs2Ua71xpn_45khGEWhHcMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/preview/expert-analysis/[vertical]/[slug].vue?macro=true";
import { default as indexSzTbYAvirp7rU6neNNmyyaD_lRtlG_45_45zszdjI8dmqEYMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/application/payment/index.vue?macro=true";
import { default as _91step_93_zZC4dKfeOcR2UqU37HyBmpFLfsHFz3eT8Ub4YjiYekMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/[step].vue?macro=true";
import { default as indexqo2d7yG1mE5U2CbEkJcq50Wum56q9QgBvPLU_iLZLyEMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/application/thankyou/index.vue?macro=true";
import { default as indexOYu3NvnOU2Bo8Ilx_45ksfU_PKIXLkgv12cZW_9IIUbE8Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/rate-rise-calculator/index.vue?macro=true";
import { default as details5v0Q0jNhaKE3jdOvgTEmVKm0Iu0Nk9sBScWJfpVCcZcMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/details.vue?macro=true";
import { default as expiredUo7KaMxFQmp_5S3luH4vjk__58zuskgi1yuBxLGERW4Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/application/payment/expired.vue?macro=true";
import { default as index2cfZjtiWSfwXyn3GUt0cox2f6YQEx_45ZPf9KUwDOVkl4Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/income-protection/quote/index.vue?macro=true";
import { default as thank_45you11EOWCaqkrkxAt3_45rvu_2mHFc1vOWrMlIn1s_45m64pYQMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/thank-you.vue?macro=true";
import { default as detailsEKygezw3rEVH79evc4JjP8mBVjAGKItPMeiIM0iil9EMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/income-protection/quote/details.vue?macro=true";
import { default as confirmation2NHVcEDMwFunbs2yOlxHHzlSK_45sNKroRb8pLql_45UY_45MMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/confirmation.vue?macro=true";
import { default as completionmyjfo_7M7kATrqegBYP6VBEBc0FE4C6LvuMMMTU7Gs8Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/completion.vue?macro=true";
import { default as quotes_45resultsUgN1k_hpftFNhL_YCFvRSxXmUKsShObOWiuAqfmn7sgMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/quotes-results.vue?macro=true";
import { default as confirmationSoRyR_45Bdn1fXH6rOSbtFjFC_45jPeNghT7hi8xAg7fEWsMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/income-protection/quote/confirmation.vue?macro=true";
import { default as _91step_93wP3YImIPUHTikTQZOeUpd8kcAmCH9DPRoGIEffLrYLkMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/form/energy/step/[step].vue?macro=true";
import { default as _91step_93eiA_45FtT2_r_WlDUdKp__45lnD_iyGeFQP7H8nMuzteizoMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/form/generic/step/[step].vue?macro=true";
import { default as _91step_93mBDMY2DgnCAc8w49uZSdtXZtnme2gMVvfjmPrbXiao8Meta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/application/[step].vue?macro=true";
import { default as _91step_93a6Qd2iwaSHi3z0bapgOJeVQxfQJgXGv5bavx2d9AP5wMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/form/home-loan/step/[step].vue?macro=true";
import { default as indexypvQIcTeSFQb9E1yyV_45XIOQKeFD6Q3a11TIdDOL_QBAMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/students-offer/[university]/form/index.vue?macro=true";
import { default as additional_45detailsRlZTWNpeFRHruh_45gXnV3cU0nIt72nrJt1IXdDTjTJKoMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/additional-details.vue?macro=true";
import { default as _91step_938_45UM5mdfzGfSeazLzMn9UUhkaoYw0LJL9MBPcegZovIMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/form/life-insurance/step/[step].vue?macro=true";
import { default as _91step_93hc0buMfk_fl_45LM9kfy2UFU6oYvyZ3gvRaa_9JKZxd0kMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/form/health-insurance/step/[step].vue?macro=true";
import { default as index_NC2V5kUF2_45GXnpf5UH2xbM759z_cJ_nQSLkUHnfISoMeta } from "/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/students-offer/[university]/terms-conditions/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginog2sPHO_hG61Uzegq_45LbnDPuihr5xgG1IMjpaEar_gwMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/login.vue")
  },
  {
    name: "verify",
    path: "/verify",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/verify.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/sitemap.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/about-us.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerG7sciBTzkby359gllzx810eBEaYf8tmM4QPw_mPGle0Meta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/register.vue")
  },
  {
    name: "complaints",
    path: "/complaints",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/complaints.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/contact-us.vue")
  },
  {
    name: "media",
    path: "/media",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/media/index.vue")
  },
  {
    name: "energy",
    path: "/energy",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/index.vue")
  },
  {
    name: "media-slug",
    path: "/media/:slug()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/media/[slug].vue")
  },
  {
    name: "partnerships",
    path: "/partnerships",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/partnerships.vue")
  },
  {
    name: "terms-of-use",
    path: "/terms-of-use",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/terms-of-use.vue")
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/careers/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/privacy-policy.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordf0eIsG3IKPudThiZJgHNcK3ewcG4hurjdU_45PT_2j7egMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/reset-password.vue")
  },
  {
    name: "car-loans",
    path: "/car-loans",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/car-loans/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexaHrh0MOiNfMNZ6r_45uN3KHGFxJSCzEAtCqQswibhBSNkMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/index.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordatDE7ddcTDvbx2edQwBjH5Sjpv37evz7R_nmOtv91TsMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/forgot-password.vue")
  },
  {
    name: "home-loans",
    path: "/home-loans",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/index.vue")
  },
  {
    name: "vertical-slug",
    path: "/:vertical()/:slug()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/[slug].vue")
  },
  {
    name: "vertical-guides",
    path: "/:vertical()/guides",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/guides.vue")
  },
  {
    name: "collection-notice",
    path: "/collection-notice",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/collection-notice.vue")
  },
  {
    name: "credit-cards",
    path: "/credit-cards",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/credit-cards/index.vue")
  },
  {
    name: "guest-set-password",
    path: "/guest/set-password",
    meta: set_45passwordg1ZyyzuvkFp2TSQo3vTZ_45q8m_uqqj2X7aanbm_45fUTKkMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/guest/set-password.vue")
  },
  {
    name: "guest-welcome-back",
    path: "/guest/welcome-back",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/guest/welcome-back.vue")
  },
  {
    name: "authorization-merge",
    path: "/authorization/merge",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/authorization/merge.vue")
  },
  {
    name: "car-insurance",
    path: "/car-insurance",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/car-insurance/index.vue")
  },
  {
    name: "credit-cards-slug",
    path: "/credit-cards/:slug()",
    meta: _91slug_93c_45UlylyxjnA4Pt0zZoFPge1iUazWLZylKk90e1l1H0IMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/credit-cards/[slug].vue")
  },
  {
    name: "post-sale-thank-you",
    path: "/post-sale-thank-you",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/post-sale-thank-you.vue")
  },
  {
    name: "life-insurance",
    path: "/life-insurance",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/index.vue")
  },
  {
    name: "personal-loans",
    path: "/personal-loans",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/personal-loans/index.vue")
  },
  {
    name: "preview-media-slug",
    path: "/preview/media/:slug()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/preview/media/[slug].vue")
  },
  {
    name: "dashboard-perks",
    path: "/dashboard/perks",
    meta: indexURf63AA1_c0QOFCUdIdIbQy2fEg5bck9D9k0Iw_45Rw3IMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/perks/index.vue")
  },
  {
    name: "expert-analysis",
    path: "/expert-analysis",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/expert-analysis/index.vue")
  },
  {
    name: "media-author-author",
    path: "/media/author/:author()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/media/author/[author].vue")
  },
  {
    name: "authorization-callback",
    path: "/authorization/callback",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/authorization/callback.vue")
  },
  {
    name: "buyer-protection-claim",
    path: "/buyer-protection-claim",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/buyer-protection-claim.vue")
  },
  {
    name: "dashboard-quotes",
    path: "/dashboard/quotes",
    meta: index2vfFVvzJ3c5nh6Ip7PlQMFZbOgm_45BKl4vvwHoUfWAzwMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/quotes/index.vue")
  },
  {
    name: "energy-quote-thank-you",
    path: "/energy/quote/thank-you",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/quote/thank-you.vue")
  },
  {
    name: "health-insurance-error",
    path: "/health-insurance/error",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/error.vue")
  },
  {
    name: "health-insurance",
    path: "/health-insurance",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/index.vue")
  },
  {
    name: "dashboard-rewards",
    path: "/dashboard/rewards",
    props: index5J1kQPhqqcS_nvX1OkG_sPqSH7VrNYSYV_ylgHAWJiwMeta?.props ?? {"verificationNeeded":true},
    meta: index5J1kQPhqqcS_nvX1OkG_sPqSH7VrNYSYV_ylgHAWJiwMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/rewards/index.vue")
  },
  {
    name: "energy-application-error",
    path: "/energy/application/error",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/application/error.vue")
  },
  {
    name: "energy-quote-form-step",
    path: "/energy/quote/form/:step()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/quote/form/[step].vue")
  },
  {
    name: "energy-quote-form-details",
    path: "/energy/quote/form/details",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/quote/form/details.vue")
  },
  {
    name: "home-loans-interest-rates",
    path: "/home-loans/interest-rates",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/interest-rates.vue")
  },
  {
    name: "preview-vertical-slug",
    path: "/preview/:vertical()/:slug()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/preview/[vertical]/[slug].vue")
  },
  {
    name: "vertical-companies",
    path: "/:vertical()/companies",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/companies/index.vue")
  },
  {
    name: "dashboard-account-settings",
    path: "/dashboard/account-settings",
    meta: account_45settingsE4wubMrkqeWsUVkmBhN_45bKA8LEjLNwDgb2FeUmCDw_gMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/account-settings.vue")
  },
  {
    name: "dashboard-onboarding",
    path: "/dashboard/onboarding",
    meta: index55q5hRmdg8akjtfbr_45Z0EakWMwgXEndeesM074ed26gMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/onboarding/index.vue")
  },
  {
    name: "health-insurance-live-chat",
    path: "/health-insurance/live-chat",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/live-chat.vue")
  },
  {
    name: "health-insurance-post-sale",
    path: "/health-insurance/post-sale",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/post-sale.vue")
  },
  {
    name: "home-loans-quote-thank-you",
    path: "/home-loans/quote/thank-you",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/quote/thank-you.vue")
  },
  {
    name: "car-insurance-comprehensive",
    path: "/car-insurance/comprehensive",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/car-insurance/comprehensive.vue")
  },
  {
    name: "credit-cards-preview-slug",
    path: "/credit-cards/preview/:slug()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/credit-cards/preview/[slug].vue")
  },
  {
    name: "life-insurance-partners-add",
    path: "/life-insurance/partners/add",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/partners/add.vue")
  },
  {
    name: schedule_45callbackC2A1Yh94GmZeqKIvMlCSl7s57ytHudcLrHzHFwz0G08Meta?.name,
    path: "/:vertical()/schedule-callback",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/schedule-callback.vue"),
    children: [
  {
    name: "vertical-schedule-callback",
    path: "",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/schedule-callback/index.vue")
  },
  {
    name: "vertical-schedule-callback-response",
    path: ":response()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/schedule-callback/[response].vue")
  }
]
  },
  {
    name: "credit-cards-redirect-slug",
    path: "/credit-cards/redirect/:slug()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/credit-cards/redirect/[slug].vue")
  },
  {
    name: "energy-application-thank-you",
    path: "/energy/application/thank-you",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/application/thank-you.vue")
  },
  {
    name: "health-insurance-live-chat-b",
    path: "/health-insurance/live-chat-b",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/live-chat-b.vue")
  },
  {
    name: "home-loans-calculators",
    path: "/home-loans/calculators",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/calculators/index.vue")
  },
  {
    name: "home-loans-quote-form-step",
    path: "/home-loans/quote/form/:step()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/quote/form/[step].vue")
  },
  {
    name: "car-insurance-redirect-slug",
    path: "/car-insurance/redirect/:slug()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/car-insurance/redirect/[slug].vue")
  },
  {
    name: "health-insurance-offers",
    path: "/health-insurance/offers",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/offers/index.vue")
  },
  {
    name: "health-insurance-partners-add",
    path: "/health-insurance/partners/add",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/partners/add.vue")
  },
  {
    name: "home-loans-calculators-type",
    path: "/home-loans/calculators/:type()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/calculators/[type].vue")
  },
  {
    name: "home-loans-quote-form-details",
    path: "/home-loans/quote/form/details",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/home-loans/quote/form/details.vue")
  },
  {
    name: "life-insurance-quote-callback",
    path: "/life-insurance/quote/callback",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/quote/callback.vue")
  },
  {
    name: "energy-application-digital-eic",
    path: "/energy/application/digital-eic",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/application/digital-eic.vue")
  },
  {
    name: "personal-loans-quote-thank-you",
    path: "/personal-loans/quote/thank-you",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/personal-loans/quote/thank-you.vue")
  },
  {
    name: "car-insurance-quote-form-step",
    path: "/car-insurance/quote/form/:step()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/car-insurance/quote/form/[step].vue")
  },
  {
    name: "expert-analysis-author-author",
    path: "/expert-analysis/author/:author()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/expert-analysis/author/[author].vue")
  },
  {
    name: "life-insurance-quote-comparison",
    path: "/life-insurance/quote/comparison",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/quote/comparison.vue")
  },
  {
    name: "life-insurance-quote-form-step1",
    path: "/life-insurance/quote/form/step1",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/quote/form/step1.vue")
  },
  {
    name: "car-insurance-quote-form-details",
    path: "/car-insurance/quote/form/details",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/car-insurance/quote/form/details.vue")
  },
  {
    name: "car-insurance-quote-form-results",
    path: "/car-insurance/quote/form/results",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/car-insurance/quote/form/results.vue")
  },
  {
    name: "expert-analysis-category",
    path: "/expert-analysis/:category()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/expert-analysis/[category]/index.vue")
  },
  {
    name: "health-insurance-partners-signup",
    path: "/health-insurance/partners/signup",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/partners/signup.vue")
  },
  {
    name: "health-insurance-quote-thank-you",
    path: "/health-insurance/quote/thank-you",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/thank-you.vue")
  },
  {
    name: "personal-loans-quote-form-step",
    path: "/personal-loans/quote/form/:step()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/personal-loans/quote/form/[step].vue")
  },
  {
    name: "expert-analysis-category-slug",
    path: "/expert-analysis/:category()/:slug()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/expert-analysis/[category]/[slug].vue")
  },
  {
    name: "health-insurance-quote-form-step0",
    path: "/health-insurance/quote/form/step0",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/form/step0.vue")
  },
  {
    name: "life-insurance-existing-customers",
    path: "/life-insurance/existing-customers",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/existing-customers.vue")
  },
  {
    name: "life-insurance-partners-thank-you",
    path: "/life-insurance/partners/thank-you",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/partners/thank-you.vue")
  },
  {
    name: "life-insurance-quote-form-details",
    path: "/life-insurance/quote/form/details",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/quote/form/details.vue")
  },
  {
    name: "personal-loans-quote-form-details",
    path: "/personal-loans/quote/form/details",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/personal-loans/quote/form/details.vue")
  },
  {
    name: "health-insurance-quote-form-step",
    path: "/health-insurance/quote/form/:step()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/form/[step].vue")
  },
  {
    name: "dashboard-vault-product-rebate",
    path: "/dashboard/vault/:product([^/]*)*/rebate",
    meta: rebateHCRYRh3_45035anWCc1xo_45AyZ1DgUP_45OB3WxfiGDPT1qUMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/rebate.vue")
  },
  {
    name: "health-insurance-application-step",
    path: "/health-insurance/application/:step()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/application/[step].vue")
  },
  {
    name: "health-insurance-quote-form-details",
    path: "/health-insurance/quote/form/details",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/form/details.vue")
  },
  {
    name: "health-insurance-quote-policy-step0",
    path: "/health-insurance/quote/policy/step0",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/policy/step0.vue")
  },
  {
    name: "health-insurance-quote-resume",
    path: "/health-insurance/quote/resume",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/resume/index.vue")
  },
  {
    name: "life-insurance-quote-customer",
    path: "/life-insurance/quote/customer",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/quote/customer/index.vue")
  },
  {
    name: "dashboard-vault-product-details",
    path: "/dashboard/vault/:product([^/]*)*/details",
    meta: detailsZWp4EL_0mmsBdDe1llfc_YOKYSvMcI_3ClH5QD0ZGG4Meta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/details.vue")
  },
  {
    name: "buyer-protection-terms-and-conditions",
    path: "/buyer-protection/terms-and-conditions",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/buyer-protection/terms-and-conditions.vue")
  },
  {
    name: "energy-compare-by-location-location",
    path: "/energy/compare-by-location/:location()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/energy/compare-by-location/[location].vue")
  },
  {
    name: "health-insurance-quote-customer",
    path: "/health-insurance/quote/customer",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/customer/index.vue")
  },
  {
    name: "health-insurance-quote-policy-details",
    path: "/health-insurance/quote/policy/details",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/policy/details.vue")
  },
  {
    name: "health-insurance-quotes-results",
    path: "/health-insurance/quotes-results",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quotes-results/index.vue")
  },
  {
    name: "life-insurance-quote-customer-success",
    path: "/life-insurance/quote/customer/success",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/quote/customer/success.vue")
  },
  {
    name: "dashboard-offers-vertical-claim-offer",
    path: "/dashboard/offers/:vertical()/claim-offer",
    meta: claim_45offercrYMue8gQwzisfW4r_45LEnQ9lhhgE_45srW8iwc3CoH_5AMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/offers/[vertical]/claim-offer.vue")
  },
  {
    name: "dashboard-vault-product-lic-details",
    path: "/dashboard/vault/:product([^/]*)*/lic-details",
    meta: lic_45detailsLQm1zSH1ZlZua_B3OKpDwHFDJThZ_1Pco0fNccqyNP0Meta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/lic-details.vue")
  },
  {
    name: "health-insurance-quote-policy-step-step",
    path: "/health-insurance/quote/policy/step/:step()",
    meta: _91step_93h3bdpxOh_45VJLe6CWJqz2dl2aQ6Bjjmxk9QA_VLpeUrMMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/quote/policy/step/[step].vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc",
    path: "/health-insurance/visitors-visa-ovhc",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/index.vue")
  },
  {
    name: "preview-expert-analysis-vertical-slug",
    path: "/preview/expert-analysis/:vertical()/:slug()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/preview/expert-analysis/[vertical]/[slug].vue")
  },
  {
    name: "health-insurance-application-payment",
    path: "/health-insurance/application/payment",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/application/payment/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-step",
    path: "/health-insurance/visitors-visa-ovhc/:step()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/[step].vue")
  },
  {
    name: "health-insurance-application-thankyou",
    path: "/health-insurance/application/thankyou",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/application/thankyou/index.vue")
  },
  {
    name: "health-insurance-rate-rise-calculator",
    path: "/health-insurance/rate-rise-calculator",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/rate-rise-calculator/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-details",
    path: "/health-insurance/visitors-visa-ovhc/details",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/details.vue")
  },
  {
    name: "health-insurance-application-payment-expired",
    path: "/health-insurance/application/payment/expired",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/application/payment/expired.vue")
  },
  {
    name: "life-insurance-income-protection-quote",
    path: "/life-insurance/income-protection/quote",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/income-protection/quote/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-thank-you",
    path: "/health-insurance/visitors-visa-ovhc/thank-you",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/thank-you.vue")
  },
  {
    name: "life-insurance-income-protection-quote-details",
    path: "/life-insurance/income-protection/quote/details",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/income-protection/quote/details.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-confirmation",
    path: "/health-insurance/visitors-visa-ovhc/confirmation",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/confirmation.vue")
  },
  {
    name: "dashboard-vault-product-vertical-completion",
    path: "/dashboard/vault/:product([^/]*)*/:vertical()/completion",
    meta: completionmyjfo_7M7kATrqegBYP6VBEBc0FE4C6LvuMMMTU7Gs8Meta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/completion.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-quotes-results",
    path: "/health-insurance/visitors-visa-ovhc/quotes-results",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/quotes-results.vue")
  },
  {
    name: "life-insurance-income-protection-quote-confirmation",
    path: "/life-insurance/income-protection/quote/confirmation",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/life-insurance/income-protection/quote/confirmation.vue")
  },
  {
    name: "dashboard-vault-product-form-energy-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/energy/step/:step()",
    meta: _91step_93wP3YImIPUHTikTQZOeUpd8kcAmCH9DPRoGIEffLrYLkMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/form/energy/step/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-generic-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/generic/step/:step()",
    meta: _91step_93eiA_45FtT2_r_WlDUdKp__45lnD_iyGeFQP7H8nMuzteizoMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/form/generic/step/[step].vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-application-step",
    path: "/health-insurance/visitors-visa-ovhc/application/:step()",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/application/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-home-loan-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/home-loan/step/:step()",
    meta: _91step_93a6Qd2iwaSHi3z0bapgOJeVQxfQJgXGv5bavx2d9AP5wMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/form/home-loan/step/[step].vue")
  },
  {
    name: "health-insurance-students-offer-university-form",
    path: "/health-insurance/students-offer/:university()/form",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/students-offer/[university]/form/index.vue")
  },
  {
    name: "dashboard-vault-product-vertical-additional-details",
    path: "/dashboard/vault/:product([^/]*)*/:vertical()/additional-details",
    meta: additional_45detailsRlZTWNpeFRHruh_45gXnV3cU0nIt72nrJt1IXdDTjTJKoMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/additional-details.vue")
  },
  {
    name: "dashboard-vault-product-form-life-insurance-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/life-insurance/step/:step()",
    meta: _91step_938_45UM5mdfzGfSeazLzMn9UUhkaoYw0LJL9MBPcegZovIMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/form/life-insurance/step/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-health-insurance-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/health-insurance/step/:step()",
    meta: _91step_93hc0buMfk_fl_45LM9kfy2UFU6oYvyZ3gvRaa_9JKZxd0kMeta || {},
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/dashboard/vault/[...product]/form/health-insurance/step/[step].vue")
  },
  {
    name: "health-insurance-students-offer-university-terms-conditions",
    path: "/health-insurance/students-offer/:university()/terms-conditions",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/health-insurance/students-offer/[university]/terms-conditions/index.vue")
  },
  {
    name: "Guides",
    path: "/credit-cards/guides",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/guides.vue")
  },
  {
    name: "Companies",
    path: "/credit-cards/companies",
    component: () => import("/codebuild/output/src3720478101/src/packages/nuxt/pages/[vertical]/companies/index.vue")
  }
]